define('entities/webshop/menu',[
  'app',
  'settings',
  'underscore'
], function (
  App,
  Settings,
  _
) {
  'use strict';

  // Main menu of the webshop (PHP webshop api/menu/**, through the backend webshop proxy), formerly
  // pushed by a Google Sheet. One version per save and locale: {TopMenu: {Items: [...]}}.
  // Errors are rejected with (message, response json).

  var call = function (type, path, params, data) {
    var defer = $.Deferred();

    var options = {
      type: type,
      url: Settings.url('compuzz2', 'webshop/menu/' + path, params || {}),
      success: function (result) {
        defer.resolve(result);
      },
      error: function (jqXHR) {
        var json = jqXHR.responseJSON || {};
        defer.reject(json.message || _.i18n('webshop.errors.unknown', null, 'Unknown error'), json, jqXHR.status);
      }
    };

    if (data) {
      options.data = JSON.stringify(data);
      options.processData = false;
      options.contentType = 'application/json';
    }

    $.ajax(options);
    return defer.promise();
  };

  var API = {
    locales: function () {
      return call('GET', 'locales');
    },
    // Menu shown on the site for the locale
    get: function (locale) {
      return call('GET', 'get', {locale: locale});
    },
    version: function (id) {
      return call('GET', 'get', {id: id});
    },
    history: function (locale) {
      return call('GET', 'history', {locale: locale});
    },
    // baseId: version loaded in the editor (409 if another one was saved since, unless force)
    save: function (locale, menu, baseId, force) {
      return call('PUT', 'save', null, {locale: locale, menu: menu, baseId: baseId, force: !!force});
    },
    // {code: {id, code, name, label, status}} for the codes that are categories
    categories: function (locale, codes) {
      return call('POST', 'categories', null, {locale: locale, codes: codes});
    },
    images: function () {
      return call('GET', 'images');
    },
    uploadImage: function (file) {
      var defer = $.Deferred();
      var formData = new FormData();
      // 'file': name expected by the backend proxy
      formData.append('file', file);

      $.ajax({
        type: 'POST',
        url: Settings.url('compuzz2', 'webshop/menu/images/upload'),
        data: formData,
        processData: false,
        contentType: false,
        success: function (result) {
          defer.resolve(result);
        },
        error: function (jqXHR) {
          var json = jqXHR.responseJSON || {};
          defer.reject(json.message || _.i18n('webshop.errors.unknown', null, 'Unknown error'));
        }
      });

      return defer.promise();
    }
  };

  return API;
});

